import { useQuery } from "@tanstack/react-query"
import { cccdAttendance } from "@/lib/api/cccdAttendanceClient"

/** Una sola consulta compartida por el lanzador, el escaneo y el reporte. */
export function useAttendanceSummary() {
  return useQuery({ queryKey: ["attendance-summary"], queryFn: cccdAttendance.getSummary, staleTime: 30_000 })
}
